import React from "react";
import {
  AltRouteOutlined,
  AssignmentOutlined,
  BlockOutlined,
  CheckCircleOutline,
  EmailOutlined,
  FactCheckOutlined,
  HourglassEmptyOutlined,
  IntegrationInstructionsOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";
import { WorkflowCanvasType } from "./workflowBuilderData";

interface WorkflowCanvasIconProps {
  type: WorkflowCanvasType;
}

const ICONS: Record<WorkflowCanvasType, React.ReactElement> = {
  form: <AssignmentOutlined />,
  approval: <FactCheckOutlined />,
  task: <TaskAltOutlined />,
  conditional: <AltRouteOutlined />,
  webservice: <IntegrationInstructionsOutlined />,
  email: <EmailOutlined />,
  pause: <HourglassEmptyOutlined />,
  cancel: <BlockOutlined />,
  finalize: <CheckCircleOutline />,
};

const WorkflowCanvasIcon: React.FC<WorkflowCanvasIconProps> = ({ type }) => ICONS[type];

export default WorkflowCanvasIcon;
